import React, { useState, useEffect } from 'react';
import { Container, Alert } from 'react-bootstrap';
import TokenManagement from '../components/Pro/TokenManagement';
import { HostInfo } from '../types';
import gameService from '../services/gameService';
import { useAuth } from '../contexts/AuthContext';

const TokensPage: React.FC = () => {
  const [hostInfo, setHostInfo] = useState<HostInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    loadHostInfo();
  }, []);

  const loadHostInfo = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await gameService.getHostInfo();
      
      if (response.success && response.data) {
        setHostInfo(response.data);
      } else {
        setError(response.message || 'Failed to load host information');
      }
    } catch (err) {
      setError('An unexpected error occurred while loading host information');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleTokenPurchase = (updatedHostInfo: HostInfo) => {
    setHostInfo(updatedHostInfo);
  };

  return (
    <Container className="py-4">
      <h2 className="mb-4">Token Management</h2>
      
      {loading && <Alert variant="info">Loading your token information...</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}
      
      {!loading && !error && (
        <TokenManagement 
          hostInfo={hostInfo || undefined}
          onTokenPurchase={handleTokenPurchase}
        />
      )}
    </Container>
  );
};

export default TokensPage;
